<template>
  <div class="loading">
    <loader :large="true" :loading="true" :black="true" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "./Loader.vue";
export default {
  components: { Loader },
  name: "LoaderOverlay",
};
</script>

<style lang="scss" scoped>
.loading {
  width: 100%;
  height: 100%;
  opacity: 0.6;
  position: absolute;
  z-index: 999999;
}
</style>
